export default {
  install(Vue, opts = {}) {
    // eslint-disable-next-line prefer-const
    let { directiveName = "skeleton", rows = 10, radius = 0, bg = "#eaebed" } = opts;
    Vue.directive(directiveName, {
      update(el, binding, vnode) {
        let { value } = binding;
        if (typeof value !== "object") {
          value = { loading: value };
        }

        /*
         * console.log('el:')
         * console.dir(el)
         * console.log('v:')
         * console.dir(vnode)
         * loading为true并且el的data-skeleton="0"或者空的时候画骨架
         */
        if (value.loading && (!el.dataset.skeleton || el.dataset.skeleton === "0")) {
          el.dataset.skeleton = "1";
          // el-table（自识别：宽度、列数、行高。可配置：行数、圆角、背景色）
          if (vnode.componentOptions && vnode.componentOptions.tag === "el-table") {
            // 隐藏空数据提示
            const totalWidth = el.clientWidth;
            const emptyText = el.querySelector(".el-table__empty-block");
            if (emptyText) {
              emptyText.style.display = "none";
            }

            // 计算每一列的宽度
            const colsWidth = [];
            let usedWidth = 0;
            let freeCount = 0;
            let cols = vnode.componentOptions.children;
            // 过滤undefined的Vnode
            cols = cols.filter(o => Boolean(o.tag) && o.tag != "template");
            for (let i = 0; i < cols.length; i++) {
              colsWidth.push(Number(cols[i].componentOptions.propsData.width));
              if (cols[i].componentOptions.propsData.width) {
                usedWidth += Number(cols[i].componentOptions.propsData.width);
              } else {
                freeCount++;
              }
            }

            // 没指定宽度的列宽 = (总宽 - 已指定的列宽总和) / 未指定列宽的个数
            const autoWidth = (totalWidth - usedWidth) / freeCount;
            for (let i = 0; i < colsWidth.length; i++) {
              if (!colsWidth[i]) {
                colsWidth[i] = autoWidth;
              }
            }

            // 在tbody中画骨架
            const tbody = el.querySelector(".el-table__body tbody");
            // 行数（缺省为5）
            rows = value.rows || rows;
            // 骨架屏背景色（缺省为#eaebed）
            bg = value.bg || bg;
            // 圆角（缺省为5）
            radius = value.radius || radius;
            for (let i = 0; i < rows; i++) {
              const tr = document.createElement("tr");
              tr.className = "skeleton-tr el-table__row";
              for (let j = 0; j < colsWidth.length; j++) {
                const td = document.createElement("td");
                td.className = "cell";
                const div = document.createElement("div");

                /*
                 * div.style = `
                 *   line-height: 15px;
                 *   margin:4px 0;
                 *   background: ${bg};
                 *   border-radius: ${radius}px;
                 *   text-indent:-999px;
                 *   width:100%;`;
                 */
                div.style = `
                  line-height: 15px;
                  margin:16px 0;
                  background-image: linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 37%,#f2f2f2 63%);
                  background-size: 400% 100%;    
                  background-position: 100% 50%;
                  border-radius: ${radius}px;
                  text-indent:-999px; 
                  width:100%;
                  animation: skeleton-loading 1.4s ease infinite;`;

                div.appendChild(document.createTextNode("."));
                td.appendChild(div);
                tr.appendChild(td);
              }
              tbody.appendChild(tr);
            }
          } else if (el.className.includes("skeleton")) {
            const skeletonRectangle = el.querySelectorAll(".skeleton-rectangle");
            // console.log(skeletonRectangle)
            skeletonRectangle.forEach(val => {
              const computedStyle = JSON.parse(JSON.stringify(val.getBoundingClientRect()));
              val.style.background = bg;
              val.style.borderRadius = radius;
              val.style.minWidth = `${computedStyle.width}px`;
              val.style.height = `${computedStyle.height}px`;
              val.innerText = "";
            });

            const skeletonCircle = el.querySelectorAll(".skeleton-circle");
            skeletonCircle.forEach(val => {
              const computedStyle = JSON.parse(JSON.stringify(val.getBoundingClientRect()));

              /*
               * val.style = `
               *   background: ${bg};
               *   border-radius: ${radius}px;
               *   min-width: ${computedStyle.width}px;
               *   height: ${computedStyle.width}px;
               *   border-radius: ${computedStyle.width}px;
               *  `;
               */
              val.style = `
                  background-image: linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 37%,#f2f2f2 63%);
                  border-radius: ${radius}px;
                  min-width: ${computedStyle.width}px;
                  height: ${computedStyle.width}px;
                  border-radius: ${computedStyle.width}px;
                  animation: skeleton-loading 1.4s ease infinite;`;
              val.innerText = "";
            });
          }
        } else if (!value.loading && el.dataset.skeleton === "1") {
          // loading为false并且el的data-skeleton="1"的时候删除骨架
          el.dataset.skeleton = "0";
          // el-table
          if (vnode.componentOptions && vnode.componentOptions.tag === "el-table") {
            const allSkeletons = el.querySelectorAll(".skeleton-tr");
            const tbody = el.querySelector(".el-table__body tbody");
            for (let i = 0; i < allSkeletons.length; i++) {
              tbody.removeChild(allSkeletons[i]);
            }
            const emptyText = el.querySelector(".el-table__empty-block");
            if (emptyText) {
              // emptyText.style.display = "block";
            }
          }
        }
      }
    });
  }
};
